import { useDispatch } from '@redux';
import {
  getByIdOrdersReturn,
  approvedOrderReturn,
} from '@redux/ordersReturn/actions';
import { Form, Input, Modal, Select } from 'antd';
import {
  RETURN_METHOD,
  RETURN_REASON,
  // WHO_PAY_SHIPPING_FEE,
} from 'constants/ordersReturn';
import useToggleModal from 'hooks/useToogleModal';
import React, {
  useCallback,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import { useTranslation } from 'react-i18next';

const ValidationModal = ({ id, initValue }, ref) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const { visible, toggleModal } = useToggleModal();
  const [loading, setLoading] = useState(false);

  useImperativeHandle(ref, () => ({
    open: () => {
      toggleModal();
    },
  }));

  const handleValidation = useCallback(
    async (values) => {
      setLoading(true);
      dispatch(approvedOrderReturn({ data: { id: id, data: values } })).then(
        () => {
          dispatch(
            getByIdOrdersReturn({
              data: { id: id },
              options: { isRequestApi: true, isRefresh: true },
            }),
          ).finally(() => {
            setLoading(false);
            if (visible) toggleModal();
          });
        },
      );
    },
    [dispatch, id, toggleModal, visible],
  );

  useEffect(() => {
    if (initValue) {
      form.setFieldsValue(initValue);
    }
  }, []);

  return (
    <Modal
      open={visible}
      title={t('ordersReturn.modal.approve')}
      onCancel={() => visible && toggleModal()}
      onOk={() => form.submit()}
      width={462}
      confirmLoading={loading}
    >
      <Form form={form} layout="vertical" onFinish={handleValidation}>
        <Form.Item
          name="returnMethod"
          label={t('ordersReturn.returnMethod')}
          rules={[{ required: true }]}
        >
          <Select placeholder="Select..." allowClear>
            {Object.values(RETURN_METHOD)?.map((item) => (
              <Select.Option key={item.value} value={item.value}>
                {t(item?.text)}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        {/* <Form.Item
          name="whoPayShippingFee"
          label={t('ordersReturn.whoPayShippingFee')}
          rules={[{ required: true }]}
        >
          <Select placeholder="Select..." allowClear>
            {Object.values(WHO_PAY_SHIPPING_FEE)?.map((item) => (
              <Select.Option key={item.value} value={item.value}>
                {t(item?.text)}
              </Select.Option>
            ))}
          </Select>
        </Form.Item> */}
        <Form.Item
          name="reason"
          label={t('ordersReturn.reasonReturn')}
          rules={[{ required: true }]}
        >
          <Select placeholder="Select..." allowClear>
            {Object.values(RETURN_REASON)?.map((item) => (
              <Select.Option key={item.value} value={item.value}>
                {t(item?.text)}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="approvalNoteToCustomer"
          label={t('ordersReturn.noteToCustomer')}
        >
          <Input.TextArea />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default React.forwardRef(ValidationModal);
